export const VALUATION_BREAKDOWN_KINDS_TO_DESCRIPTION_KINDS = {
  top_income_types: "income_type_analysis",
  top_music_users: "music_user_analysis",
  top_songs: "song_analysis",
  top_sources: "source_analysis",
};

export const INTERNATIONAL_SOURCE_DISPLAY_NAME = "International Sources";
export const earningSourceNameToDisplayName: { [key: string]: string } = {
  "TV-FILM": "TV and Film",
  STREAMING: "Streaming",
  "STREAMING VIDEO": "Streaming Video",
  "RETAIL MUSIC SERVICE": "Retail Plays",
  LIVE: "Live Performance",
  OTHER: "Other",
  INTERNATIONAL: INTERNATIONAL_SOURCE_DISPLAY_NAME,
  SYNCHRONIZATION: "Sync",
  ADJUSTMENTS: "Adjustments",
};
